import { Jute } from "../..";

export const convertTimeDifferenceToString = (oldTime: number, newTime: number): string => {
    // Find the distance between now and the count down date
	const deltaTime = newTime - oldTime;
    // Time calculations for hours, minutes and seconds
    let minutes: number | string = Math.floor((deltaTime % (1000 * 60 * 60)) / (1000 * 60));
    let seconds: number | string = Math.floor((deltaTime % (1000 * 60)) / 1000);

    if (minutes < 10) minutes = '0' + minutes;
    if (seconds < 10) seconds = '0' + seconds;

    return minutes + ":" + seconds;
}

//const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const createRecordingStream = (canvas: HTMLCanvasElement): MediaStream => {
    const stream = canvas.captureStream();

    //await sleep(200);

    // ensure at least one audio source node connected
    const silence = Jute.audioContext.createBufferSource();
    silence.connect(Jute.audioStreamDestination);
    silence.start();

    // add sound tracks of videos and audio to canvas stream
    for (const track of Jute.audioStreamDestination.stream.getAudioTracks()) {
        stream.addTrack(track);
    }

    return stream;
}